import { createFileRoute } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import React from "react";

const getNewCoachCount = createServerFn({ method: "GET" }).handler(async () => {
  const { getDBWithInit } = await import("~/lib/db");
  const { coaches } = await import("~/../drizzle/schema");
  const { count, isNotNull, and, gte } = await import("drizzle-orm");

  const thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

  const [result] = await (
    await getDBWithInit()
  )
    .select({ count: count() })
    .from(coaches)
    .where(
      and(gte(coaches.createdAt, thirtyDaysAgo), isNotNull(coaches.approvedAt)),
    );

  return result.count;
});

export const Route = createFileRoute("/embed/new-coaches-30d/")({
  loader: async () => {
    const newCoachCount = await getNewCoachCount();
    return { newCoachCount };
  },
  component: NewCoaches30dPage,
});

function NewCoaches30dPage() {
  const { newCoachCount } = Route.useLoaderData();

  return (
    <div className="flex h-screen w-screen items-center justify-center bg-white">
      <div className="font-heading text-[min(40vw,40vh)] tabular-nums">
        {newCoachCount}
      </div>
    </div>
  );
}
